import {  ResourceOperationEfficiencyDto } from "@gtpl/shared-models/planning";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllResourceOperationEfficiencyResponseModel extends GlobalResponseObject {
    data?: ResourceOperationEfficiencyDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ResourceOperationEfficiencyDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

